export default __webpack_public_path__ + "static/media/sinn.9e4da77f.mp3";